import React from 'react'
import Typography from '@material-ui/core/Typography'
import CardContent from '@material-ui/core/CardContent'

function StoryItemText(props) {
  const { asset, color } = props

  return (
    <li
      style={{ listStyleType: 'none' }}
    >
      <CardContent>
        <Typography
            className="c-body"
            variant="body1"
            component="p"
            style={{ color}}
            dangerouslySetInnerHTML={{ __html: asset.cleanText }} />
      </CardContent>
    </li>
  )
}

export default StoryItemText
